import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ScheduleFlag } from '../../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../../domain/user.model';
import { SidenavActionPayload, SidenavService } from '../../../service/sidenav.service';
import { SidenavAction, SidenavSide } from '../../../store/aside.action';
import { ScheduleState } from '../../../store/schedule.state';
import { UserState } from '../../../store/user.state';

@Component({
    selector: 'app-menu',
    templateUrl: './menu-aside.component.html',
    styleUrls: ['./menu-aside.component.scss']
})
export class MenuAsideComponent implements OnInit, OnDestroy {

    user: SystemUser;
    flag: ScheduleFlag;
    subscriptions: Subscription[] = [];

    get isSeller(): boolean {
        return [EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES].indexOf(this.user.entityRole) !== -1;
    }

    get readonly(): boolean {
        if (!this.user) {
            return true;
        }
        return this.flag.active === false
            || !this.isSeller;
    }

    constructor(private sidenavService: SidenavService,
                private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    close() {
        this.sidenavService.dispatch(new SidenavActionPayload(SidenavSide.LEFT, SidenavAction.CLOSE));
    }
}
